export * from './SearchResultView';
